// extracted by mini-css-extract-plugin
export default {"ageLogo":"ClientPage_ageLogo__rnO56"};